export const refundTitles = {
  original_payment_method: 'Método de pago original',
  bank_transfer: 'Reembolso instantáneo',
  store_credit: 'Crédito en tienda',
  gift_card: 'Tarjeta regalo',
}
